import { Box, Button, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import { useHistory } from "react-router-dom";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import AccountMenu from "./messaging/AccountMenu";

const NavBarNew = ({ showSample }) => {
  const history = useHistory();

  const downloadSampleCSV = (isHistorical = false) => {
    const s3Url = isHistorical
      ? "https://niroggyan.s3.ap-south-1.amazonaws.com/smartReportSampleCSVTrends.csv"
      : "https://niroggyan.s3.ap-south-1.amazonaws.com/smartReportSampleCsv.csv";
    const link = document.createElement("a");
    link.href = s3Url;
    link.setAttribute("download", ""); // This forces the download
    document.body.appendChild(link);
    link.click(); // Trigger the click
    document.body.removeChild(link); // Clean up the DOM
  };

  const handleLogout = () => {
    localStorage.clear();
    history.push("/login");
  };

  return (
    <Box
      sx={{
        background: "#E9F5FE",
        height: "70px",
        padding: "0px 8%",
        display: "flex",
        alignItems: "center",
        gap: 1,
        flexWrap: "wrap",
      }}
    >
      <Box flexGrow={1}>
        <Link to="/">
          <img
            src="https://niroggyan.s3.ap-south-1.amazonaws.com/websitelogos/Niroggyan_logo.svg"
            alt="niroggyan logo"
          />
        </Link>
      </Box>
      <Stack direction="row" alignItems="center" gap={3}>
        <Typography>
          <Link to="/">Home</Link>
        </Typography>
        <Typography>
          <Link to="/messaging">Messaging </Link>
        </Typography>
        {/* {showSample && (
          <Button onClick={() => downloadSampleCSV()}>Sample CSV</Button>
        )} */}
        {showSample && (
          <Dropdown data-bs-theme="dark">
            <Dropdown.Toggle
              id="dropdown-button-dark-example1"
              variant="primary"
              style={{
                background: "#3567D6",
                borderRadius: "8px",
                padding: "4px 16px",
                fontSize: "16px",
              }}
            >
              Sample CSV
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item active onClick={() => downloadSampleCSV()}>
                Without Trends
              </Dropdown.Item>
              <Dropdown.Item onClick={() => downloadSampleCSV(true)}>
                With Trends
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}
        {/* <Button onClick={handleLogout}>
          Logout{" "}
          <span className="ms-2">
            <LogoutIcon />
          </span>
        </Button> */}
        {/* settings */}
        <AccountMenu />
      </Stack>
    </Box>
  );
};

export default NavBarNew;
